import { EnrichedProfessionalService } from 'services/api/entities/events/types/internal/services'
import {
  yupArray,
  yupIgnore,
  yupNumber,
  YupSchema,
  yupString,
} from 'services/yup'
import { professionalSelectionVS } from '../selections/professionals'
import { enrichedProductServiceVS } from './productService'

export const enrichedProfessionalServiceVS: YupSchema<EnrichedProfessionalService> =
  enrichedProductServiceVS.shape({
    id: yupNumber().required(),
    name: yupIgnore(),
    notes: yupString().optional(),
    specialType: yupIgnore(),
    selections: yupArray(professionalSelectionVS).min(1),
  })
